import { useQuery } from '@tanstack/react-query';

import { fetchAppSettings } from '../api/settingsApi';

export const ADMIN_SETTINGS_QUERY_KEY = ['admin', 'settings'] as const;

export function useAppSettings() {
  return useQuery({
    queryKey: ADMIN_SETTINGS_QUERY_KEY,
    queryFn: fetchAppSettings,
  });
}
